// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"fa45fe94","154":"6f83a3ed","580":"e92a2174"}[chunkId] + ".chunk.css";
};